import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=d4971826&scoped=true&"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=d4971826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4971826",
  null
  
)

export default component.exports